export default "__VITE_ASSET__SepiCSvg__"